import { uppercase } from "@src/utils/character-utils";
import "./characterFeatuers.sass";
import { useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Features } from "@src/types/global";
interface IProps {
    features: Features;
}
/**
 * Features box
 * TODO : Make it resizable in case it hides the image under
 * @param features - The features to display
 */
const CharacterFeatures = ({ features }: IProps) => {
    // const [height, setHeight] = useState("30dvh");
    const [{ height }, api] = useSpring(() => ({
        from: { opacity: 0, height: "0dvh" },
        to: {
            opacity: 1,
            height: "30dvh",
        },
        config: { mass: 2, tension: 350, friction: 40 },
    }));
    const resizerRef = useRef<HTMLSpanElement | null>(null);
    function handleDrag(clientY: number) {
        const windowHeight = window.innerHeight;
        let res = 100 - (clientY / windowHeight) * 100;
        if (res > 80) {
            res = 80;
        }
        if (res < 20) {
            res = 20;
        }
        api({ height: `${res}dvh` });
    }

    return (
        <animated.div
            className="features__container"
            style={{ height: height }}
        >
            <span
                aria-hidden={true}
                className="features__resizer"
                ref={resizerRef}
                onPointerDown={(e) => {
                    resizerRef.current!.setPointerCapture(e.pointerId);
                }}
                onPointerMoveCapture={(e) => {
                    if (e.buttons == 0) {
                        return;
                    }
                    handleDrag(e.clientY);
                }}
                onPointerUp={(e) =>
                    resizerRef.current!.releasePointerCapture(e.pointerId)
                }
            ></span>
            {Object.entries(features).map(([key, value]) => {
                return (
                    <div className="features__item" key={key}>
                        <h4>{uppercase(key)}</h4>
                        <p>{value}</p>
                    </div>
                );
            })}
        </animated.div>
    );
};
export default CharacterFeatures;
